import React from "react";
import InternalDrawer from "../EventInformation/InternalDrawer";
import { Templates } from "pages/Communication/Components/Templates/Templates";

const NotificationTemplate = (props) => {
    const formik = props;
  return (
   <div className="class_info_container">
      <div className="left_section">
        <div className="left_content">
              <Templates componentCalled={'event'} formik={formik}/>
        </div>
      </div>
      <div className="right_sectoin">
        <InternalDrawer formik={formik} />
      </div>
    </div>
  );
};

export default NotificationTemplate;
